// extracted by mini-css-extract-plugin
export default {"iconContainer":"Matches-Description_iconContainer__slVYF","button":"Matches-Description_button__E2tiC","wrapContainer":"Matches-Description_wrapContainer__t53rX"};